module.exports = __webpack_public_path__ + "img/login-background3.8ddabcfe.jpg";